import React from 'react';
import { Icon } from '@chakra-ui/react';

export const ReferralIcon = () => {
	return (
		<Icon
			width="12px"
			height="12px"
			viewBox="0 0 10 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_1582_7858)">
				<path
					d="M7.65743 3.93652H4.22234C3.80075 3.93652 3.45898 4.27829 3.45898 4.69988V8.13497C3.45898 8.55656 3.80075 8.89833 4.22234 8.89833H7.65743C8.07902 8.89833 8.42079 8.55656 8.42079 8.13497V4.69988C8.42079 4.27829 8.07902 3.93652 7.65743 3.93652Z"
					stroke="white"
					stroke-width="0.763354"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M1.93409 6.22645H1.55242C1.34996 6.22645 1.1558 6.14603 1.01264 6.00287C0.869487 5.85971 0.789063 5.66555 0.789062 5.4631V2.028C0.789062 1.82555 0.869487 1.63139 1.01264 1.48823C1.1558 1.34507 1.34996 1.26465 1.55242 1.26465H4.98751C5.18997 1.26465 5.38413 1.34507 5.52728 1.48823C5.67044 1.63139 5.75087 1.82555 5.75087 2.028V2.40968"
					stroke="white"
					stroke-width="0.763354"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1582_7858">
					<rect
						width="9.16025"
						height="9.16025"
						fill="white"
						transform="translate(0.0253906 0.501953)"
					/>
				</clipPath>
			</defs>
		</Icon>
	);
};

export default ReferralIcon;
